export const SRP_TYPES = {
    PAIRED_CHECKLIST: 'PAIRED_CHECKLIST',
    CHECKLIST: 'CHECKLIST',
    MULTI_CATEGORIES: 'MULTI_CATEGORIES',
    SEARCHABLE_CHECKLIST: 'SEARCHABLE_CHECKLIST',
    GROUPED_CHECKLIST: 'GROUPED_CHECKLIST',
    COLOR: 'COLOR',
    RANGE: 'RANGE',
} as const;
